import Clock from "@/assets/icons/clock.svg";
import useGetStringifiedDateAndHour from "@/hooks/utils/useGetStringifiedDate";

interface EventDateTimeProps {
    startDateTime: Date;
    endDateTime: Date;
}

const EventDateTime = ({ startDateTime, endDateTime }: EventDateTimeProps) => {
    const getStringifiedDate = useGetStringifiedDateAndHour();

    return (
        <div className="flex items-center gap-2">
            <img alt="Clock" className="text-icon-active h-4 w-4" src={Clock} />
            {getStringifiedDate(startDateTime, endDateTime)}
        </div>
    );
};

export default EventDateTime;
